import {
  ActionType,
  CreateParametricStoreRequest,
  CreateFailureAction,
  CreateRequestedAction,
  CreateSuccessAction,
  DeleteFailureAction,
  DeleteRequestedAction,
  DeleteSuccessAction,
  ListFailureAction,
  ListRequestedAction,
  ListSuccessAction,
  ParametricStore,
  UpdateFailureAction,
  UpdateParametricStoreRequest,
  UpdateRequestedAction,
  UpdateSuccessAction,
} from './types';
import { HttpRequestError } from '../../types';

export const parametricStoresListRequested = (country: string): ListRequestedAction => ({
  type: ActionType.listRequested,
  country,
});

export const parametricStoresListSuccess = (data: ParametricStore[]): ListSuccessAction => ({
  type: ActionType.listSuccess,
  data,
});

export const parametricStoresListFailure = (error: HttpRequestError): ListFailureAction => ({
  type: ActionType.listFailure,
  error,
});

export const parametricStoresCreateRequested = (
  payload: CreateParametricStoreRequest
): CreateRequestedAction => ({
  type: ActionType.createRequested,
  payload,
});

export const parametricStoresCreateSuccess = (data: ParametricStore): CreateSuccessAction => ({
  type: ActionType.createSuccess,
  data,
});

export const parametricStoresCreateFailure = (error: HttpRequestError): CreateFailureAction => ({
  type: ActionType.createFailure,
  error,
});

export const parametricStoresUpdateRequested = (
  country: string,
  code: string,
  payload: UpdateParametricStoreRequest
): UpdateRequestedAction => ({
  type: ActionType.updateRequested,
  country,
  code,
  payload,
});

export const parametricStoresUpdateSuccess = (
  country: string,
  code: string,
  payload: UpdateParametricStoreRequest
): UpdateSuccessAction => ({
  type: ActionType.updateSuccess,
  country,
  code,
  payload,
});

export const parametricStoresUpdateFailure = (error: HttpRequestError): UpdateFailureAction => ({
  type: ActionType.updateFailure,
  error,
});

export const parametricStoresDeleteRequested = (
  country: string,
  code: string
): DeleteRequestedAction => ({
  type: ActionType.deleteRequested,
  country,
  code,
});

export const parametricStoresDeleteSuccess = (
  country: string,
  code: string
): DeleteSuccessAction => ({
  type: ActionType.deleteSuccess,
  country,
  code,
});

export const parametricStoresDeleteFailure = (error: HttpRequestError): DeleteFailureAction => ({
  type: ActionType.deleteFailure,
  error,
});
